module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p5-B-d68756e2f931a639670a0ba803d9fefe.png";